import React, { useState, useEffect } from "react";
import "./index.less";
import { useLocation, useNavigate } from "react-router-dom";
import ImproveUserInfoComponent from "@/components/ImproveUserInfoComponent";
import UserSvg from '@/assets/user.svg'
import UserSvgActive from '@/assets/userActive.svg'
import OrderSvg from '@/assets/order.svg'
import OrderSvgActive from '@/assets/orderActive.svg'

export default function Info(props) {
    const location = useLocation();
    const [info, setInfo] = useState('');
    const [toDetail, setToDetail] = useState(null);
    const [orderSvg, setOrderSvg] = useState(OrderSvg);
    const [userSvg, setUserSvg] = useState(UserSvg);
    const [selectItem, setSelectItem] = useState(location.state);
    const [orderType, setOrderType] = useState('');
    const searchParams = new URLSearchParams(location.search);
    const queryParams = new URLSearchParams(window.location.search);
    const navigate = useNavigate()


    const urlToDetail = () => {
        setToDetail(searchParams.get('id'))
    }
    useEffect(() => {
        urlToDetail();
        setSelectItem(queryParams.get('menu'))
        setInfo(queryParams.get('menu'))
        if (queryParams.get('menu') === 'user') {
            setOrderSvg(OrderSvg)
            setUserSvg(UserSvgActive)
        } else {
            setOrderSvg(OrderSvgActive)
            setUserSvg(UserSvg)
        }
        // setInfo(location.state)
    }, [location.state])
    return (
        <>
            <div className="userInfo-background">
                <div className="userInfo-content">
                    <ImproveUserInfoComponent></ImproveUserInfoComponent>
                </div>
            </div>
        </>
    );

}

